// Global
import React from 'react';
import styles from './HeroDecor.module.scss';
import clsx from 'clsx';

export const HeroDecor = () => {
  return (
    <div className={clsx(styles.decorWrapper)}>
      <svg
        className={styles.decorColor}
        xmlns="http://www.w3.org/2000/svg"
        width="1400"
        height="331"
        fill="none"
      >
        <path d="M0 331H746.181L1400 0V331H0Z" fill="currentColor" />
      </svg>
    </div>
  );
};
